import React from 'react'
import createReactClass from 'create-react-class'

const MgCancelled =  createReactClass({
	render() {
		const { migrate, history } = this.props
		return <span>
			<div className="col-xs-8 col-md-8 bv-landing-section">
				<i className="mdi mdi-close-circle-outline"></i>
				<p className="bv-landing-title">
					Migration Cancelled
				</p>
				<p className="bv-landing-para dark-gray">
					<strong>Source :</strong>{ migrate.get('source_site') }
				</p>
				<p className="bv-landing-para dark-gray">
					<strong>Destination :</strong>{ migrate.get('destination_site') }
				</p>
				<a className="bv-primary-button bv-mobile-button" onClick={history.goBack}>Back to Site</a>
			</div>
		</span>
	}
})

export default MgCancelled
